import { Box } from '@mui/material'
import ReportFilterHeader from './ReportFilterHeader'
import VirtualizedTable from './VirtualizedTable'
import SearchFilter from './SearchFilter'
import { useState } from 'react'

const ReportTable = (props) => {
    const { reportTitle = '', reportFilterCol = [], filterData = {}, tableData = [], columnDefs = [], totalColumnDef = [],
        tableHeaderContent = null,
        tableBodyContent = null, id = 'mainTable',
        tableLayout = 'fixed', tableWidth = '100%', tableClassName = '' } = props
    const [matches, setMatches] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const tables = [
        { id: id, data: tableData, columnDefs: columnDefs, totalColDef: totalColumnDef },
    ]
    return (
        <Box>
            <SearchFilter
                tables={
                    tables
                }
                matches={matches}
                setMatches={setMatches}
                currentIndex={currentIndex}
                setCurrentIndex={setCurrentIndex}
            />
            <ReportFilterHeader
                reportTitle={reportTitle}
                reportFilterCol={reportFilterCol}
                filterData={filterData}
            />
            <Box sx={{ padding: '16px', paddingBottom: '70px', overflowX: 'auto' }}>
                <VirtualizedTable
                    id={id}
                    tableData={tableData}
                    columnDefs={columnDefs}
                    totalColumnDef={totalColumnDef}
                    tableHeaderContent={tableHeaderContent}
                    tableBodyContent={tableBodyContent}
                    matches={matches}
                    currentIndex={currentIndex}
                    tableLayout={tableLayout}
                    tableWidth={tableWidth}
                    tableClassName={tableClassName}
                />
            </Box>
        </Box>
    )
}

export default ReportTable